import config from 'config';
import { noop } from 'lodash';

const trace = new Map<string, string>();
const logUsePageLayoutCalls = (pathName: string) => {
  return;
  const stack = new Error().stack ?? '';
  const callSite = stack
    .split('\n')[3]
    .trim()
    .replace(/\d+:\d+/, ''); // removes line number `123:45` from the stack trace

  if (callSite && trace.has(pathName) && trace.get(pathName) !== callSite) {
    trace.delete(pathName);
    alert(`[Page Layout] usePageLayout called twice for ${pathName} route. 
            Present call origin: ${callSite}
            Previous call origin: ${trace.get(pathName)}.


            Please ensure that usePageLayout has only one origin for each route.
            `);
  } else {
    trace.set(pathName, `${callSite}`);
  }
};

const calledOnlyOnce = config.vercel_env || !config.is_prod ? logUsePageLayoutCalls : noop;

export default calledOnlyOnce;
